import { Injectable } from "@angular/core";
import { AuthenticationService } from "../_services/auth.service";
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AppConfigService } from "../_services/app-config.service";
import { clearLocalStorageExceptCharts } from '../_helpers/window.helper';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild
} from "@angular/router";


@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private adalSvc: MsAdalAngular6Service,
    private appConfigService: AppConfigService) { }



    async canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Promise<boolean> {
    const currentUser = localStorage.getItem("currentUser");
    if (currentUser ) {
      await this.appConfigService.ensureLoaded();
      return true;
    }

    clearLocalStorageExceptCharts();

    // Redirect if no SSO token is found
    this.router.navigate(["auth/login"]);
    return false;
  }


  canActivateChild(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }
}
